import React from 'react';
import PropTypes from 'prop-types';

const BatchStatus = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Skrá";
      break;
    case 2:
      displayText = "Afskrá";
      break;
    default:
      displayText = "Unknown";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

BatchStatus.propTypes = {
  data: PropTypes.number,
};

export default BatchStatus;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Display/RecordAction.js